import React, { useState, useEffect } from "react";
import * as c from "./wistiaVideoEmbedCustomPlayButton.module.scss";
import classNames from "classnames";
import { IconPlayAlt } from "@icons/iconPlayAlt";
import useUserAgent from "@hooks/useUserAgent";

export default function WistiaVideoEmbedCustomPlayButton({ wistiaPlayer }) {
  const { isMobile } = useUserAgent();

  const [isPlayButtonEnabled, setIsPlayButtonEnabled] = useState(false);
  const [isPlayButtonHidden, setIsPlayButtonHidden] = useState(false);

  const onPlay = () => {
    setIsPlayButtonHidden(true);
  };

  const onPause = () => {
    setIsPlayButtonHidden(false);
  };

  // We disable the custom button after the first play on mobile
  // since the native controls take over after the initial play
  const onFirstPlayMobile = () => {
    if (isMobile) {
      setIsPlayButtonHidden(true);
      setIsPlayButtonEnabled(false);

      wistiaPlayer.unbind("play", onPlay);
      wistiaPlayer.unbind("pause", onPause);
    }

    wistiaPlayer.unbind("play", onFirstPlayMobile);
  };

  const togglePlaying = () => {
    if (isPlayButtonEnabled) {
      const isPlaying = wistiaPlayer.state() === "playing";

      if (isPlaying) {
        wistiaPlayer.pause();
        setIsPlayButtonHidden(false);
      } else {
        wistiaPlayer.play();
        setIsPlayButtonHidden(true);
      }
    }
  };

  useEffect(() => {
    if (wistiaPlayer && wistiaPlayer.ready()) {
      wistiaPlayer.bind("play", onPlay);
      wistiaPlayer.bind("play", onFirstPlayMobile);
      wistiaPlayer.bind("pause", onPause);

      setIsPlayButtonEnabled(true);
    }
  }, [wistiaPlayer]);

  return (
    <>
      {isPlayButtonEnabled && (
        <div className={classNames(c.customPlayButtonWrapper, { [c.isHidden]: isPlayButtonHidden })}>
          <IconPlayAlt className={c.customPlayButton} onClick={togglePlaying} />
        </div>
      )}
    </>
  );
}
